import { Subject } from 'rxjs';
import { JobType } from 'src/app/shared/models/job-types.model';
import { Attachment } from 'src/app/shared/models/uploaded-file-list.model';
import { JobDetailsMode } from '../../constants/assign-trade.constant';
import {
  PropertyType,
  WorkflowStates,
} from '../../constants/job-detail.constants';
import {
  IssueReportedTypeLabel,
  PropertyKeyCollectTypeLabel,
  StrataPropertyKeyCollectTypeLabel,
} from '../../constants/job-post/job-post.enum-map';
import {
  IssueReportedType,
  JobBudgetOptions,
  JobPostSteps,
  JobPriority,
  JobRecurranceCustomType,
  JobRecurranceType,
  JobUrgencyOptions,
  MaintenanceType,
  OutboundPartnerIdType,
  PayerTypeEnum,
  PropertyKeyCollectType,
  TargetTradeOption,
} from '../../constants/job-post/job-post.enums';
import { AssetResult } from '../asset.model';
import { ActivationStatus } from 'src/app/shared/models/Enums';
import { AiAssets, Assets } from 'src/app/shared/models/ai-models/ai-assets.model';

export class Job {
  static instance: Job;
  id: string;
  mode: JobDetailsMode = JobDetailsMode.NONE;
  currentStep: JobPostSteps;
  issueReportedType: IssueReportedType;
  jobRequestedUserEmail: string;
  title: string;
  description: string;
  tenantNotRequired: boolean;
  tenant: Tenant;
  tenantOptions: Tenant[];
  owners: Owner[];
  property: Property;
  assignPms: AssignPm[];
  payer: Payer;
  defaultPayer: Payer;
  primaryJobType: JobType;
  secondaryJobType: JobType;
  attachments: Attachment[];
  budget: Budget;
  prevBudget: Budget;
  maintenanceType: MaintenanceType;
  recurrence: Recurrence;
  urgencyType: number;
  priority: Priority;
  keyCollectionType: any;
  jobNote: Note;
  tradeNote: Note;
  assignTrades: AssignTrades;
  drafteJob: boolean;
  isPropertySelectedByOutSite: boolean;
  isOwnerAttending: boolean;
  isHideTenantDetailsToOwner: boolean;
  isOwnerApprovalRequested: boolean;
  defultTimeZoneDiffMinutes: number;
  isOwnerApprovalThresholdExceeded: boolean = false;
  isTenantNotRequired: boolean;
  canShowRelatedJobsDrawer: boolean = false;
  isChildRecurringJob: boolean = false;
  accessContact: string;
  isStrataMasterEnabled: boolean = false;
  $isStrataEnabledProperty: Subject<boolean>;
  notifyTrade: boolean = true;
  specialNoteToTrade: string = '';
  reasonNotToNotifyTrade: string = '';
  serviceConsumerId: string;
  jobDueDate: Date;
  hasRecurringChildJobs: boolean;
  $targetTradeeOption: Subject<TargetTradeOption>;
  lastChildJobDueDate: Date;
  customKeyCollectionValue: string = '';
  workflowStatusId: WorkflowStates;
  thirdPartyName: string;
  thirdPartyEmailAddress: string;
  isUrgencyPriorityChange:boolean=false;
  jobWarningNotes: string;
  assets: Asset[];
  isCloneWithJobNotes: boolean = false;

  payerDescription:string;
  outboundPartnerId: OutboundPartnerIdType;
  ownerThreshold: number;
  scannedAssets:AssetResult[]=[];
  isSaveScannedAssets: boolean=false;
  doNotNotifyTrade:boolean =false;
  aiAssets:Assets[]=[];
  isFromAiJobPost: boolean = false;
  selectedaiAssets:Assets[]=[];
  
  selectedPayer:Payer;
  isJobApprovalThresholdExceede: boolean = false;
  isInvoiceApprovalThresholdExceeds:boolean=false;
  noAssetMatched: boolean = false;
  isFromAssetRecommendations: boolean = false;
  assetRecommendationId:string;
  private constructor() {
    this.currentStep = JobPostSteps.HowIssueReported;
    this.description = '';
    this.tenant = new Tenant();
    this.tenantOptions = [];
    this.owners = [];
    this.property = new Property();
    this.assignPms = [];
    this.payer = new Payer();
    this.defaultPayer = new Payer();
    this.primaryJobType = new JobType();
    this.secondaryJobType = new JobType();
    this.attachments = [];
    this.budget = new Budget();
    this.prevBudget = new Budget();
    this.maintenanceType = MaintenanceType.Paid;
    this.recurrence = new Recurrence();
    this.priority = new Priority();
    //this.keyCollectionType = PropertyKeyCollectType.ContactTenant;
    this.jobNote = new Note(true);
    this.tradeNote = new Note();
    this.assignTrades = new AssignTrades();
    this.drafteJob = false;
    this.isOwnerApprovalRequested = false;
    this.accessContact = '';
    this.isStrataMasterEnabled = false;
    this.$isStrataEnabledProperty = new Subject<boolean>();
    this.$targetTradeeOption = new Subject<TargetTradeOption>();
    this.isUrgencyPriorityChange = false;
    this.jobWarningNotes = '';
    this.assets = [];
    this.isCloneWithJobNotes = false;
    this.aiAssets=[];
    this.selectedaiAssets=[];
  }

  public static getInstance(): Job {
    if (!Job.instance) Job.instance = new Job();
    return Job.instance;
  }

  get payerChanged() {
    return (
      (this.payer?.id &&
        this.payer?.type != PayerTypeEnum.EXTERNAL &&
        this.payer?.id != this.defaultPayer?.id) ||
      (this.payer?.type == PayerTypeEnum.EXTERNAL &&
        this.payer?.email != this.defaultPayer?.email)
    );
  }

  issueReportedTypeLabel() {
    return IssueReportedTypeLabel.get(this.issueReportedType);
  }

  next() {
    if (this.issueReportedType == IssueReportedType.FromEmail)
      this.currentStep = this.nextStepOnReportedViaEmail();
    else if (this.issueReportedType == IssueReportedType.FromCall)
      this.currentStep = this.nextStepOnReportedViaCall();
    else this.currentStep = this.nextStepOnReportedViaInvoiceOnly();
    return this.currentStep;
  }

  nextStepOnReportedViaEmail() {
    if (this.currentStep == JobPostSteps.UploadReceivedEmail)
      return this.afterUploadReceivedEmail();
    if (
      this.currentStep == JobPostSteps.AdditionalDetails &&
      this.assignTrades.offerJobToPreviouslyDoneJobTrade
    )
      return JobPostSteps.JobPreview;
    return ++this.currentStep;
  }

  afterUploadReceivedEmail() {
    //if (this.noDataFetchFromEmail()) return JobPostSteps.AddIssueDetails;
    return JobPostSteps.VerifyDetails;
  }

  nextStepOnReportedViaCall() {
    if (this.currentStep == JobPostSteps.HowIssueReported)
      return JobPostSteps.AddIssueDetails;
    if (
      this.currentStep == JobPostSteps.AdditionalDetails &&
      this.assignTrades.offerJobToPreviouslyDoneJobTrade &&
      this.assignTrades.trades.length > 0
    )
      return JobPostSteps.JobPreview;
    return ++this.currentStep;
  }

  nextStepOnReportedViaInvoiceOnly() {
    if (this.currentStep == JobPostSteps.HowIssueReported)
      return JobPostSteps.AddIssueDetails;
    return ++this.currentStep;
  }

  back() {
    if (this.issueReportedType == IssueReportedType.FromEmail)
      this.currentStep = this.backStepOnReportedViaEmail();
    else if (this.issueReportedType == IssueReportedType.FromCall)
      this.currentStep = this.backStepOnReportedViaCall();
    else this.currentStep = this.backStepOnReportedViaInvoiceOnly();
    return this.currentStep;
  }

  backStepOnReportedViaEmail() {
    if (this.currentStep == JobPostSteps.VerifyDetails)
      return JobPostSteps.HowIssueReported;
    if (
      this.currentStep == JobPostSteps.JobPreview &&
      this.assignTrades.offerJobToPreviouslyDoneJobTrade
    )
      return JobPostSteps.AdditionalDetails;
    return --this.currentStep;
  }

  backStepOnReportedViaCall() {
    if (this.currentStep == JobPostSteps.AddIssueDetails)
      return JobPostSteps.HowIssueReported;
    if (
      this.currentStep == JobPostSteps.JobPreview &&
      this.assignTrades.offerJobToPreviouslyDoneJobTrade &&
      this.assignTrades.trades.length > 0
    )
      return JobPostSteps.AdditionalDetails;
    return --this.currentStep;
  }

  backStepOnReportedViaInvoiceOnly() {
    if (this.currentStep == JobPostSteps.AddIssueDetails)
      return JobPostSteps.HowIssueReported;
    return --this.currentStep;
  }

  isInvoiceOnlyJob() {
    return this.issueReportedType == IssueReportedType.InvoiceOnly;
  }

  noDataFetchFromEmail() {
    return (
      this.title && this.description && this.property?.id
      // this.tenant.id &&
      // this.owner.id &&
      // this.assignPms.length > 0 &&
      // this.payer.id &&
      // this.primaryJobType.id &&
      // this.secondaryJobType.id
    );
  }

  keyCollectionOptionLabel() {
    if (
      this.isStrataMasterEnabled &&
      this.property.propertyType == PropertyType.Strata
    )
      return StrataPropertyKeyCollectTypeLabel.get(this.keyCollectionType);
    else return PropertyKeyCollectTypeLabel.get(this.keyCollectionType);
  }

  clearWarrantyJobSelection() {
    this.assignTrades = new AssignTrades();
    //this.budget.option = JobBudgetOptions.UnSure;
    if (this.prevBudget) this.budget = this.prevBudget;
  }

  switchToWarantyJob() {
    this.prevBudget = Object.assign({}, this.budget);
    this.budget.amount = 0;
    this.budget.option = JobBudgetOptions.Custom;
    this.assignTrades.trades = [];
    this.assignTrades.external = <any>{};
  }

  getMinDate(numberOfDays: number = 0, isEmergencyType: boolean = false) {
    var minDate = new Date();
    var dateVariant: number = numberOfDays > 0 ? numberOfDays : isEmergencyType ? 0 : 3;
    minDate.setDate(minDate.getDate() + dateVariant);
    minDate.setHours(0, 0, 0, 0);
    console.log(1111, minDate);
    return minDate;
  }

  dueDate(numberOfDays: number = 0, isEmergencyType: boolean = false) {
    var minDate = new Date();
    var dateVariant: number = numberOfDays > 0 ? numberOfDays : isEmergencyType ? 0 : 3;
    minDate.setDate(minDate.getDate() + dateVariant);
    if(!isEmergencyType)
      minDate.setHours(0, 0, 0, 0);
    return minDate;
  }

  getMaintanaceTypeLabel() {
    return MaintenanceType[this.maintenanceType];
  }

  getNumberOfDaysInDateRange(start, end): number {
    const startDate = new Date(start);
    const endDate = new Date(end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;
    const diffInTime = endDate.getTime() - startDate.getTime();
    const diffInDays = Math.round(diffInTime / oneDay);
    return diffInDays;
  }

  public static distroyObj() {
    Job.instance = undefined;
  }
  isTenantNotRequiredOrVacant(): boolean {
    if (this.tenantNotRequired || this.tenantOptions[0]?.name == 'Vacant') {
      return true;
    }
    return false;
  }
}

export class Tenant {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  isPrimary: boolean;
  propertyTenantId: string;
  isActive: boolean;
  activationStatus: number;
  isCurrentTenant: boolean;
  isUnsubscribed: boolean;
}

export class Owner {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  isPrimary: boolean;
  isUnsubscribed: boolean;
}

export class Property {
  id: string;
  name: string;
  address: string;
  propertyType: PropertyType;
  organizationId: string;
  suburbId: string;
  isVacant: boolean;
  maintenanceNote: string;
  hasStrataDetails: boolean;
  strataLotNumber: string;
  strataCompany: string;
  strataEmail: string;
  strataPhone: string;
  strataPlanNumber: string;
  strataContacts = new Array<StrataContactModel>();
  jobCostForOwnerApproval: number;
  tenantCount: number;
  isDeactivated: boolean;
  realtyAssistThreshhold: number;
  ownerThreshold: number;
  notifyOwnerFutureJobs: boolean;
}

export class StrataContactModel {
  name: string;
  phone: string;
  email: string;
}

export class AssignPm {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  profileImageUrl: string;
}

export class Payer {
  id: string;
  name: string;
  displayName: string;
  type: PayerTypeEnum;
  email?: string;
  phoneNumber?: string;
  isActive:boolean;
}

export class Tradee {
  id: string;
  name: string;
}

export class Recurrence {
  type: JobRecurranceType;
  start: Date;
  end: Date;
  customType?: JobRecurranceCustomType;
  daysToNotify: number;
  firstRecurrenceDueDate: Date;
  noOfRecurrences?: number;
  isUnlimited: boolean;

  constructor() {
    this.type = JobRecurranceType.None;
    this.start = new Date();
    this.end = null;
    this.firstRecurrenceDueDate = new Date();
    this.daysToNotify = -1;
    this.noOfRecurrences = null;
    this.isUnlimited = false;
  }
}

export class Priority {
  type: JobPriority;
  dueDate?: Date;

  constructor() {
    this.type = JobPriority.Normal;
    this.dueDate = new Date();
    this.dueDate.setDate(this.dueDate.getDate() + 7);
    this.dueDate.setHours(0, 0, 0, 0);
  }
}

export class Note {
  text: string;
  isPrivate: boolean;
  attachmentData: Attachment[] = [];

  constructor(isPrivate: boolean = false) {
    this.isPrivate = isPrivate;
  }
}

export class Budget {
  option: JobBudgetOptions;
  amount: number;
  maxAmount: number;

  constructor() {
    this.option = JobBudgetOptions.UnSure;
    this.amount = 0;
    this.maxAmount = 0;
  }
}

export class Urgency {
  option: JobUrgencyOptions;

  constructor() {
    this.option = JobUrgencyOptions.None;
  }
}

export class AssignTrades {
  offerJobToPreviouslyDoneJobTrade: boolean;
  targetTadeeOption: TargetTradeOption;
  trades: Tradee[] = [];
  notifyOwner: boolean;
  external: {
    companyEmail: string;
    companyName: string;
  };
}

export class Asset {
  id: string;
  name: string;
  model: string;
  barcode: string;
  description: string;
  make: string;
  status: number;
  note: string;
  maintenanceCycle: AssetMaintenanceCycleType;
  jobsCount?: number;
  isSelected : boolean;
  isSharedWithTrade:boolean;
  cost:number;
  isUpdatedAssestDetailsAvailable : boolean =false;
}
export enum AssetMaintenanceCycleType {
  None = -1,
  LessThanWeek = 0,
  InMonth = 1,
  InThreeMonths = 2,
  InSixMonths = 3,
  InYear = 4,
  WithinTwoYeas = 5
}

export const AssetMaintenanceCycleTypeOptions = [
  { key: AssetMaintenanceCycleType.None, value: 'None' },
  { key: AssetMaintenanceCycleType.LessThanWeek, value: 'Less than a week' },
  { key: AssetMaintenanceCycleType.InMonth, value: 'In a month' },
  { key: AssetMaintenanceCycleType.InThreeMonths, value: 'In a three months' },
  { key: AssetMaintenanceCycleType.InSixMonths, value: 'In a six months' },
  { key: AssetMaintenanceCycleType.InYear, value: 'In a year' },
  { key: AssetMaintenanceCycleType.WithinTwoYeas, value: 'Within two years' }
]
